import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, RouteReuseStrategy } from '@angular/router';
import { appRouting } from '@app/app.routing';
import { HealthRouteReuseStrategy } from '@app/core/route-reuse/health-route-reuse.strategy';
import { AppComponent } from './app.component';
import { AppNavigationModule } from '@app/shared/components/app-navigation/app-navigation.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '@env/environment';
import { SharedModule } from '@app/shared/shared.module';
import { CoreModule } from '@app/core/core.module';
import { FeaturesModule } from '@app/features/features.module';
import { PageNotFoundComponent } from '@core/page-not-found/page-not-found.component';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { HttpErrorInterceptor } from '@core/services/http-error.interceptor';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

const oktaAuth = new OktaAuth({
  issuer: environment.oktaIssuerUrl,
  clientId: environment.clientId,
  redirectUri: environment.redirectUrl + '/implicit/callback',
  scopes: ['openid', 'profile', 'email', 'network-devices:read', 'network-devices:write'],
  pkce: false,
  responseType: ['id_token', 'token']
});

@NgModule({ declarations: [
        AppComponent,
        PageNotFoundComponent
    ],
    bootstrap: [AppComponent], imports: [OktaAuthModule,
        CoreModule,
        SharedModule,
        FeaturesModule,
        BrowserModule,
        RouterModule,
        AppNavigationModule,
        BrowserAnimationsModule,
        appRouting,
        FormsModule,
        MatIconModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: OKTA_CONFIG,
            useValue: { oktaAuth }
        },
        {
            provide: RouteReuseStrategy,
            useClass: HealthRouteReuseStrategy
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
